"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqData = [{
  question: "KIEDY I GDZIE ODBYWA SIĘ OBÓZ?",
  answer: "Obóz sportowy New Wave Camp odbędzie się w dniach 17–28 sierpnia na egzotycznej wyspie Koh Samui w Tajlandii. Naszą bazą treningową będzie legendarny klub Lamai Muay Thai, znany z najwyższej jakości szkolenia i profesjonalnej atmosfery."
}, {
  question: "JAKI JEST KOSZT I CO ZAWIERA CENA?",
  answer: "Całkowity koszt obozu to 1300 euro. Cena obejmuje 12-dniowy intensywny program treningowy pod okiem Dawida Kasperskiego i lokalnych mistrzów, zakwaterowanie w pokojach dwuosobowych, dwa posiłki dziennie, udział w zaplanowanych wycieczkach oraz lokalne atrakcje. Cena nie obejmuje biletów lotniczych ale obejmuje za to transfer z lotniska do hotelu, transfery na wycieczki i także po zakończeniu obozu. Po zarezerwowaniu miejsca pomożemy z zakupem biletu lotniczego jeśli będzie taka potrzeba."
}, {
  question: "CZY POTRZEBUJĘ DOŚWIADCZENIA W SZTUKACH WALKI?",
  answer: "Absolutnie nie. Zapraszamy zarówno osoby początkujące, które chcą rozpocząć swoją przygodę z Muay Thai i kickboxingiem, jak i zaawansowanych zawodników pragnących szlifować technikę pod okiem profesjonalnego fightera. Treningi nie są obowiązkowe, każdy może rozwijać się we własnym tempie. Jeśli chcesz wziąć ze sobą osobę towarzyszącą wyślij zgłoszenie i napisz o tym w formularzu odezwiemy się do Ciebie drogą email lub poprzez whatsapp i zaoferujemy niższą cenę niż z programem treningowym."
}, {
  question: "JAK WYGLĄDA PLAN DNIA I ATRAKCJE DODATKOWE?",
  answer: "Każdy dzień jest precyzyjnie zaplanowany. Oprócz sesji treningowych, przewidzieliśmy czas na regenerację, wspólne posiłki z autentyczną tajską kuchnią oraz wycieczki po Koh Samui, takie jak wizyty w świątyniach czy rajskie plaże."
}, {
  question: "JAK DOKONAĆ REZERWACJI I PŁATNOŚCI?",
  answer: "Aby zarezerwować miejsce, należy wypełnić formularz w zakładce Kontakt. Po rejestracji otrzymasz instrukcje dotyczące wpłaty zaliczki w wysokości 300 euro lub pełnej kwoty wyjazdu, co gwarantuje miejsce na obozie."
}];
export default function Faq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="8342" id="faq" ref={ref} className={cn("relative w-full py-20 lg:py-32 lg:min-h-screen lg:flex lg:items-center bg-background transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
      {}
      <div className="absolute inset-0 z-0 h-full w-full">
        <div className="absolute inset-0 bg-black/70 z-10 bg-[position:center_top] bg-[size:115%] bg-no-repeat !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583198/img/image_2tpp8fsc.jpg)] sm:hidden" />
        <div className="absolute inset-0 h-full w-full bg-cover bg-center bg-no-repeat bg-[url(https://newwavecamp.com/wp-content/uploads/2026/03/camp_arrival_color.webp)] hidden md:block" />
      </div>

      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none overflow-hidden z-10">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-primary/10 rounded-full blur-3xl" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-secondary/10 rounded-full blur-3xl" />
      </div>

      <div className="container relative mx-auto px-4 md:px-6 z-20">
        <div className="max-w-3xl mx-auto text-center mb-12 md:mb-20">
          <h2 className="font-serif text-4xl md:text-6xl lg:text-7xl font-bold text-foreground mb-4 tracking-tighter uppercase">
            Często Zadawane Pytania
          </h2>
          <p className="text-lg md:text-xl text-primary font-bold tracking-widest uppercase">
            Wszystko, co musisz wiedzieć o obozie
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="rounded-2xl border border-primary/20 bg-card/40 backdrop-blur-2xl shadow-2xl p-6 md:p-10 lg:p-12">
            <Accordion type="single" collapsible className="w-full">
              {faqData.map((item, i) => <div key={i} data-index={i}>
                  <AccordionItem value={`item-${i}`} className="border-b-0 mb-8 last:mb-0">
                    <AccordionTrigger className="hover:no-underline py-4 md:py-6 group">
                      <span className="text-left font-serif font-black text-lg md:text-2xl text-foreground group-hover:text-primary transition-colors tracking-tight uppercase">
                        {item.question}
                      </span>
                    </AccordionTrigger>
                    <AccordionContent className="pb-10">
                      <p className="font-sans font-normal text-base md:text-lg text-foreground md:text-muted-foreground leading-relaxed">
                        {item.answer}
                      </p>
                    </AccordionContent>
                    {i < faqData.length - 1 && <Separator className="mt-4 bg-primary/10" />}
                  </AccordionItem>
                </div>)}
            </Accordion>
          </div>
        </div>
      </div>
    </section>;
}